<div class="promo-card-container">
  <fcom-promo-card
    [imageData$]="promoData$ | finMap: 'picture'"
    [data$]="promoData$"
    [ctaData$]="promoCta$"
    [aspectRatio]="'4x3'"
    [isTextOnTop]="true"
    [theme]="PromoTheme.FULL_BG"
  ></fcom-promo-card>
</div>
